<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card title="Gestion des annonces">
          <div class="flex md12">
            <div class="row row-inside">
              <div class="flex md1">
                <div
                  class="numeroDisp-mod"
                  :style="{ backgroundColor: backgroundColor() }"
                >
                  <va-button
                    v-if="idprevious"
                    flat
                    icon="fa fa-arrow-left"
                    :color="backgroundColor()"
                    class="button-left"
                    @click="changePage(idprevious)"
                  />
                  <va-button
                    v-if="idnext"
                    flat
                    icon="fa fa-arrow-right"
                    :color="backgroundColor()"
                    class="button-right"
                    @click="changePage(idnext)"
                  />
                  <div
                    class="nb-pub"
                    v-if="!publication.hors_serie"
                  >
                    {{ publication.numero }}
                  </div>
                  <div
                    class="hs-pub"
                    v-else
                  >HORS-SERIE</div>
                  <div class="dp-pub">
                    {{
											moment(
												publication.date_previsionnelle,
												"YYYY-MM-DD"
											).format("DD-MM-YYYY")
										}}
                  </div>
                </div>
              </div>
              <div class="flex md2">
                <div class="row row-inside">
                  <div class="flex md11 offset--md1">
                    <va-button
                      color="gray"
                      class="fullwidth"
                      @click=""
                    >Editer une facture</va-button>
                  </div>
                  <div class="flex md11 offset--md1">
                    <va-button
                      color="gray"
                      class="fullwidth"
                      @click=""
                    >Editer toutes
                      factures</va-button>
                  </div>
                </div>
              </div>
              <div class="flex md2">
                <div class="row row-inside">
                  <div class="flex md11 offset--md1">
                    <va-button
                      color="gray"
                      class="fullwidth"
                      @click="getBilan()"
                    >Télécharger
                      Bilan</va-button>
                  </div>
                  <div class="flex md11 offset--md1">
                    <va-button
                      color="gray"
                      class="fullwidth"
                      @click="showBilan = true"
                    >Voir
                      Bilan</va-button>
                  </div>
                </div>
              </div>
              <div class="flex md2 offset--md1">
                <div class="row row-inside">
                  <div class="flex md12">
                    <va-chip
                      class="fullwidth chips annoncesstat"
                      color="info"
                    >{{ statistiques.nbPages
										}} pages /
                      {{ statistiques.nbannonces }} annonces</va-chip>
                    <div class="fullwidth centered annoncesstat">Nb annonces / Pages</div>
                  </div>
                  <div class="flex md12">
                    <va-chip
                      class="fullwidth chips annoncesstat"
                      color="info"
                    >{{
											statistiques.nbPages_pro }} pages /
                      {{ statistiques.nbannonces }} annonces</va-chip>
                    <div class="fullwidth centered annoncesstat">Nb annonces / Pages prospection</div>
                  </div>
                </div>
              </div>
              <div class="flex md2">
                <div class="row row-inside">
                  <div class="flex md12">
                    <va-chip
                      class="fullwidth chips annoncesstat"
                      :color="statistiques.resultatPrev > 0 ? 'success' : 'danger'"
                    >{{
												statistiques.resultatPrev }} €</va-chip>
                    <div class="fullwidth centered annoncesstat">Résultat prévisionnel</div>
                  </div>
                  <div class="flex md12">
                    <va-chip
                      class="fullwidth chips annoncesstat"
                      color="info"
                    >{{
											statistiques.produitPrev_pro }} €</va-chip>
                    <div class="fullwidth centered annoncesstat">Produit prospection</div>
                  </div>
                </div>
              </div>
              <div class="flex md2">
                <div class="row row-inside">
                  <div class="flex md12">
                    <va-chip
                      class="fullwidth chips annoncesstat"
                      :color="statistiques.resultatEff > 0 ? 'success' : 'danger'"
                    >{{
												statistiques.resultatEff }} €</va-chip>
                    <div class="fullwidth centered annoncesstat">Résultat réalisé</div>
                  </div>
                  <div class="flex md12">
                    <va-button-toggle
                      outline
                      small
                      color="info"
                      class="toggle-activite"
                      v-model="showProspection"
                      :options="optionsProspection"
                    />

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row row-inside separator">
            <div class="flex md1 col-title">Partenaire</div>
            <div class="flex md1 col-title">Kit média</div>
            <div class="flex md1 col-title">Devis</div>
            <div class="flex md1 col-title">Montant proposé</div>
            <div class="flex md1 col-title">Format</div>
            <div class="flex md1 col-title">Retour client</div>
            <div class="flex md1 col-title">Visuel</div>
            <div class="flex md1 col-title">Facture</div>
            <div class="flex md1 col-title">Montant reçu</div>
            <div class="flex md1 col-title">Relances</div>
            <div class="flex md1 col-title">Alertes</div>
            <div class="flex md1 col-title">Attribué</div>
          </div>
          <div class="row row-inside">
            <div
              class="flex md12"
              v-for="(element, index) in listAnnonces "
              :key="index"
            >
              <annonces-liste-line
                :idannonce="element.idannonce"
                v-on:reloadList="reloadList"
                v-show="element.showannonce"
              />
            </div>
          </div>
          <div
            class="flex md2 offset--md10 mt-4"
            v-if="this.$store.getters.user.publication_modifications"
          >
            <va-button
              color="info"
              @click="createNew()"
            >
              <va-icon
                size="15px"
                name="fa fa-plus"
              />
              <span>&nbsp Ajouter un annonceur</span></va-button>
          </div>
        </va-card>
      </div>
    </div>
    <devis-creation
      v-model="showNewDevis"
      @newdevis="initPublication()"
    />
    <va-modal
      class="modal"
      v-model="showBilan"
      max-width="100%"
      hideDefaultActions
    >
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center"
      >
        <span lang="FR">******

          <p></p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center"
      >
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <table
        class="MsoNormalTable"
        border="0"
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse"
      >
        <tr style="height: 19.5pt">
          <td
            width="626"
            colspan="2"
            style="
					width: 469.2pt;
border: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 19.5pt;
								                                                                                      "
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align: center"
            >
              <b>
                <span lang="FR">
                  Bilan numéro {{ statistiques.numero ? statistiques.numero : 'Hors-Série' +
										moment(statistiques.date_previsionnelle).format('MMMM YYYY') }}

                  <p></p>
                </span>
              </b>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td
            width="236"
            style="
width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Date de parution&nbsp;:

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ statistiques.date_parution ? moment(statistiques.date_parution).format('DD/MM/YYYY') :
								moment(statistiques.date_previsionnelle).format('DD/MM/YYYY') +
								'(Prévisionnelle)' }}

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 19.5pt">
          <td
            width="236"
            style="
width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 19.5pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Nombre d'annonces&nbsp;:

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 19.5pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ statistiques.nbannonces }} &nbsp;({{ statistiques.pages }} Pages / {{ statistiques.demiPages
							}} demi
              pages /
              {{ statistiques.quartPages }} quart de pages / {{ statistiques.autres }} Autres )
            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td
            width="236"
            style="
width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Coûts routage&nbsp;:

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ statistiques.cout_routage ? statistiques.cout_routage : '-' }} €
            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td
            width="236"
            style="
width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Coûts d'impression

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ statistiques.cout_impression ? statistiques.cout_impression : '-' }} €
            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td
            width="236"
            style="
width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Coût de conception / rédaction&nbsp;:

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ statistiques.cout_conception ? statistiques.cout_conception : '-' }} €
            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td
            width="236"
            style="
width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Coût total&nbsp;:

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ coutTotal() }} €
            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td
            width="236"
            style="
width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Produit prévisionnel&nbsp;:

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ statistiques.produitPrev ? statistiques.produitPrev : '-' }} €
            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td
            width="236"
            style="
							width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Produit réalisé&nbsp;:

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ statistiques.produitEff ? statistiques.produitEff : '-' }} €
            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td
            width="236"
            style="
width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Résultat prévisionnel&nbsp;:

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ statistiques.resultatPrev ? statistiques.resultatPrev : '-' }} €
            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td
            width="236"
            style="
width: 176.9pt;
border: solid windowtext 1pt;
border-top: none;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              Résultat effectué&nbsp;:

            <p></p>
            </p>
          </td>
          <td
            width="390"
            style="
width: 292.3pt;
border-top: none;
border-left: none;
border-bottom: solid windowtext 1pt;
border-right: solid windowtext 1pt;
padding: 0cm 5.4pt 0cm 5.4pt;
height: 18.7pt;
								                                                                                      "
          >
            <p class="MsoNormal">
              {{ statistiques.resultatEff ? statistiques.resultatEff : '-' }} €

            <p></p>
            </p>
          </td>
        </tr>
      </table>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center"
      >
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center"
      >
        <span lang="FR">******

          <p></p>
        </span>
      </p>

    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, sortedUniq, sortBy, find } from "lodash";
import moment from "moment";
import DevisCreation from "./devisCreation";
import AnnoncesListeLine from "./annoncesListeLine";

export default {
  name: "annonces-list",
  props: ["idnumero"],
  components: { DevisCreation, AnnoncesListeLine },

  data() {
    return {
      //export within context
      moment: moment,
      publication: this.resetPublication(),
      idnext: null,
      idprevious: null,
      showNewDevis: false,
      listAnnoncesRaw: [],
      statistiques: { pages: 0 },
      showBilan: false,
      optionsProspection: [
        { label: "Toutes", value: "all" },
        { label: "Prosp.", value: "prospection" },
        { label: "Commer.", value: "commercial" },

      ],
      showProspection: "all",
    };
  },
  created() {
    this.initPublication();
  },
  watch: {
    idnumero() {
      this.initPublication();
    },
  },
  computed: {
    listAnnonces() {


      let tmp = sortBy(this.listAnnoncesRaw, ["nom"]);
      for (let ijk = 0; ijk < tmp.length; ijk++) {
        tmp[ijk].showannonce = true
        if (this.showProspection === 'prospection' && !tmp[ijk].isprospection) {
          tmp[ijk].showannonce = false
        } else if (this.showProspection === 'commercial' && tmp[ijk].isprospection) {
          tmp[ijk].showannonce = false
        }
      }
      return tmp
    }
  },
  methods: {
    coutTotal() {
      let cout = 0;
      if (this.statistiques.cout_routage) {
        cout = parseFloat(this.statistiques.cout_routage);
      }
      if (this.statistiques.cout_impression) {
        cout = parseFloat(this.statistiques.cout_impression);
      }
      if (this.statistiques.cout_conception) {
        cout = parseFloat(this.statistiques.cout_conception);
      }
      return cout;
    },

    async reloadList(idannonce) {
      console.log("there");
      await this.getListAnnonces();
      // todo open the devis for the modified annonce
    },
    async getBilan() {
      try {
        let res = await axios.get("/api/publications/bilan", {
          params: { idpublication: this.idnumero },
        });

        this.statistiques = res.data;

        console.log(this.statistiques);
      } catch (error) {
        this.launchEpicmaxToast(
          "Erreur lors du chargement de la liste des annonces"
        );
        console.log(error);
      }
    },
    async getListAnnonces() {
      try {
        this.listAnnoncesRaw = [];
        let res = await axios.get("/api/publications/liste-annonces", {
          params: { idpublication: this.idnumero },
        });

        this.listAnnoncesRaw = res.data;
      } catch (error) {
        this.launchEpicmaxToast(
          "Erreur lors du chargement de la liste des annonces"
        );
        console.log(error);
      }
    },
    resetPublication() {
      return {
        idpublication: null,
        numero: null,
        date_creation: moment().format("YYYY-MM-DD"),
        date_parution: null,
        date_routage: null,
        date_reception: null,
        date_cloture: null,
        date_ouverture: null,
        cout_routage: null,
        cout_impression: null,
        produit_previsionnel_final: null,
        produit_effectif: null,
        cout_conception: null,
        diffusion_partenaires: null,
        diffusion_entreprises: null,
        listing: false,
        pdf: false,
        date_previsionnelle: moment().format("DD-MM-YYYY"),
        hors_serie: false,
        isactif: false,
      };
    },
    async initPublication() {
      if (this.idnumero) {
        this.loadPublication();
        this.getListAnnonces();
        this.getBilan();
      } else {
        try {
          let tmpRes = await axios.get("/api/publications/active");

          this.$router.push({
            name: "annonces",
            params: { idnumero: tmpRes.data },
          });
        } catch (error) {
          console.log(error);
          this.launchEpicmaxToast(
            "Erreur lors du chargement de la publication"
          );
        }
      }
    },
    backgroundColor() {
      if (this.publication.isactif) {
        return "#4ae387";
      } else if (this.publication.date_cloture) {
        return "#ccc";
      } else {
        return "#4ab2e3";
      }
    },
    changePage(idpublication) {
      if (idpublication) {
        this.$router.push({
          name: "annonces",
          params: { idnumero: idpublication },
        });
      }
    },
    async loadPublication() {
      try {
        let resTmpPublication = await axios.get(
          "api/publications/publication",
          {
            params: { idpublication: this.idnumero },
          }
        );

        let resTmpNeighbors = await axios.get("api/publications/neighbors", {
          params: { idpublication: this.idnumero },
        });

        this.publication = cloneDeep(resTmpPublication.data);
        this.idnext = resTmpNeighbors.data.next;
        this.idprevious = resTmpNeighbors.data.previous;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast(
          "Erreur lors de la récupération de la liste des publications"
        );
      }
    },
    createNew() {
      if (!this.$store.getters.user.publication_modifications) {
        return;
      }
      this.showNewDevis = true;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.boxed-green {
  width: 95%;
  text-align: center;
}

.centered {
  font-weight: bold;
  text-align: center;
}

.chips {
  font-size: 1.1em;
  font-weight: bold;
}

.col-title {
  font-size: 0.8em;
  text-align: center;
  font-weight: bold;
}

.separator {
  border-bottom: 1px solid black;
}

.fullwidth {
  width: 95%;
  margin: 0;
}

.container {
  text-align: center;
  min-height: 6em;
}

.container:hover {
  cursor: pointer;
}

.numero-box {
  color: white;
  font-size: 1.5em;
  font-weight: bold;
}

.hors-series-text {
  color: white;
  font-size: 1em;
  font-weight: bold;
}

.date-box {
  color: white;
}

.numeroDisp-mod {
  position: relative;
  min-height: 4em;

  span {
    outline: none !important;
  }
}

.nb-pub {
  padding: 0;
  margin: 0;
  color: white;
  font-weight: bold;
  font-size: 2em;
  text-align: center;
}

.dp-pub {
  padding: 0;
  margin: 0;
  color: white;
  text-align: center;
}

.hs-pub {
  padding: 0;
  margin: 0;
  padding-top: 1em;
  color: white;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}

.button-left {
  position: absolute;
  left: -2.5em;
  top: 1em;
}

.button-right {
  position: absolute;
  right: -2.5em;
  top: 1em;
}

.annoncesstat {
  font-size: 0.9em;
}
</style>
